import {useTranslation} from "react-i18next";
import rygLogo from "../../../assets/images/ryg-logo03.png";

const logoRygCls = "[&_img]:w-[var(--size-100)] [&_img]:block [&_img]:mx-auto";
const tosContainerCls =
  "m-5 font-[var(--font-family)] leading-[1.6] [&_h2]:text-2xl [&_h2]:mb-[var(--space-3-75)] [&_h2]:text-white [&_p]:mb-[var(--space-3)] [&_strong]:font-bold [&_strong]:text-[var(--color-info)]";

const DeleteAccount = () => {
  const {t} = useTranslation();

  return (
    <>
      <div className={logoRygCls}>
        <img
          src={rygLogo}
          alt="Ryg Logo"
        />
      </div>
      <div className={tosContainerCls}>
        <h2>{t("deleteAccountTitle")}:</h2>
        <p>
          {t("deleteAccountContent")}
          <a href="mailto:soporte@aprietaygana.com?subject=Solicitud%20de%20eliminación%20de%20cuenta">
            soporte@aprietaygana.com
          </a>
          {t("deleteAccountInfo")}
          <p>{t("deleteAccountInfo2")}</p>
        </p>
      </div>
    </>
  );
};

export default DeleteAccount;
